import { Card } from '../../../design';
import { fmtDateTime } from '../../../lib/format';
import type { LockerDetail } from '../common';
import { LayoutGrid, LayoutLegend } from '../LayoutGrid';
import s from '../lockers.module.css';

export function OverviewTab({ locker: l }: { locker: LockerDetail }) {
  const total = l.slots.length;
  const free = l.slots.filter((x) => x.occupancy === 'free' && x.techState === 'active').length;
  const occupied = l.slots.filter((x) => x.occupancy === 'occupied').length;
  const reserved = l.slots.filter((x) => x.occupancy === 'reserved').length;
  const blocked = l.slots.filter((x) => x.techState === 'blocked').length;
  const open = l.slots.filter((x) => x.doorOpen).length;
  const fill = total ? Math.round(((occupied + reserved) / total) * 100) : 0;
  return (
    <div className="stack">
      <div className={s.kpis}>
        <div className={s.kpi}>
          <strong>{free}</strong>
          <span>compartimente libere din {total}</span>
        </div>
        <div className={s.kpi}>
          <strong>{occupied}</strong>
          <span>ocupate</span>
        </div>
        <div className={s.kpi}>
          <strong>{reserved}</strong>
          <span>rezervate</span>
        </div>
        <div className={s.kpi}>
          <strong style={{ color: fill >= l.rules.fillAlertPct ? 'var(--orange)' : undefined }}>
            {fill}%
          </strong>
          <span>grad de ocupare (alertă la {l.rules.fillAlertPct}%)</span>
        </div>
        <div className={s.kpi}>
          <strong style={{ color: open ? 'var(--red)' : undefined }}>{open}</strong>
          <span>uși deschise · {blocked} blocate tehnic</span>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 16 }}>
        <Card>
          <h2>Layoutul fizic</h2>
          <p className="muted small" style={{ marginBottom: 12 }}>
            {l.grid.cols} coloane · {l.boards.length} plăci · doar vizualizare (editarea în
            „Compartimente & layout”)
          </p>
          <LayoutGrid
            cols={l.grid.cols}
            control={l.grid.control}
            slots={l.slots}
            boards={l.boards}
          />
          <LayoutLegend />
        </Card>
        <Card>
          <h2>Controler și conectivitate</h2>
          <dl
            className="small"
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: '6px 14px',
              marginTop: 12,
            }}
          >
            <dt className="muted">Dispozitiv</dt>
            <dd>
              {l.controller.deviceLabel} · {l.controller.os}
            </dd>
            <dt className="muted">Ecran</dt>
            <dd>
              {l.controller.screenInches}″ · {l.controller.resolution.width}×
              {l.controller.resolution.height} ·{' '}
              {l.controller.orientation === 'portrait' ? 'portret' : 'peisaj'}
            </dd>
            <dt className="muted">Aplicație</dt>
            <dd>{l.controller.appVersion || '—'}</dd>
            <dt className="muted">Serial</dt>
            <dd className="mono">
              {l.controller.serial.port} · {l.controller.serial.baud} {l.controller.serial.dataBits}
              {l.controller.serial.parity[0]?.toUpperCase()}
              {l.controller.serial.stopBits}
            </dd>
            <dt className="muted">Plăci</dt>
            <dd>
              {l.boards
                .map(
                  (b) =>
                    `${b.name} (adr. ${b.address}, ${b.mappedDoors}/${b.doors} ieșiri, ${b.status})`,
                )
                .join('; ')}
            </dd>
            <dt className="muted">Ultimul contact</dt>
            <dd>{fmtDateTime(l.lastSeenAt)}</dd>
            {l.maintenanceNote && (
              <>
                <dt className="muted">Mentenanță</dt>
                <dd>{l.maintenanceNote}</dd>
              </>
            )}
          </dl>
        </Card>
      </div>
    </div>
  );
}
